import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const GlobeIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="7.5" fill="#C292FF" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.76928 4.40851C3.71787 5.23753 3.6795 5.85614 4.91671 6.47474C6.41671 7.22474 7.1667 7.59974 7.5417 8.72474C7.6272 8.98124 7.6932 9.25722 7.75749 9.52604L7.7575 9.52605C7.97518 10.4363 8.1732 11.2642 9.0417 10.9747C10.1667 10.5997 11.2917 9.47474 10.9167 7.97474C10.6552 6.92891 11.3053 6.24766 11.85 5.67681C12.0865 5.42891 12.3032 5.20183 12.4167 4.97474C12.4735 4.86121 12.5474 4.73049 12.6282 4.58778L12.6282 4.58776C12.9162 4.07869 13.2904 3.41714 13.2786 2.8393C12.0651 1.99499 10.5904 1.5 9.00005 1.5C7.07858 1.5 5.32587 2.22257 3.99884 3.41082C3.91636 3.57238 3.84676 3.7213 3.79171 3.84974C3.79171 4.04684 3.7802 4.23242 3.76928 4.40851ZM11.7129 15.9943C11.3222 15.1984 10.955 13.6034 11.607 11.7695C12.0294 10.5813 12.7727 9.79426 13.6744 9.25599C14.6754 8.65843 15.8019 8.73416 16.4946 9.28856C16.3788 12.3491 14.4292 14.9401 11.7129 15.9943ZM1.6626 10.5604C2.17981 13.0045 3.88741 15.0093 6.15022 15.9396C6.38365 15.2124 6.34987 14.0696 5.99421 12.5952C5.39318 10.1034 3.35919 9.80933 1.6626 10.5604Z"
      fill="#774EAA"
    />
  </SvgIcon>
);

export default GlobeIcon;
